export default class Meigaranews2recentService {
  getAll(params) {
      const queryParams = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
      return fetch('https://api.tradersr.com/api/meigaranews2recent?' + queryParams).then(res => res.json())
  }
}